export default __webpack_public_path__ + "static/media/thumb-up.fdb33011.svg";